// test2122
(2122 && 0);
